import React, { useState, useEffect } from "react";
import { useStateContext } from "../contexts/ContextProvider";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Footer from "../components/Footer/Footer";

const Submission = () => {
  const navigate = useNavigate();
  const [link, setLink] = useState("");
  const [genre, setGenre] = useState("")
  const [category, setCategory] = useState("");
  const [email, setEmail] = useState("");
  const [referral, setReferral] = useState("");
  const { channels, getAllChannels } = useStateContext();
  const [description, setDescription] = useState("");

  const handleLinkChange = (e) => {
    setLink(e.target.value);
  };

  const handleCategoryChange = (e) => {
    let text = e.target.selectedOptions[0].label
    let arr = text.split(" ("); 
    let category = arr[0]
    let genre = arr[1].replace(")", "")
    setCategory(category);
    setGenre(genre);
    setDescription(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleReferralChange = (e) => {
    setReferral(e.target.value);
  };

  useEffect(() => {
    getAllChannels();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      link.includes("spotify") &&
      (link.includes("track") || link.includes("album"))
    ) {
      try {
        const data = {
          email: email,
          category: category,
          sLink: link,
          referral: referral,
        };
        console.log(data);

        const response = await axios(
          {
            method: "post",
            url: `${process.env.REACT_APP_BACKEND_API_SERVER}/submit`,
            data: data,
            mode: "no-cors",
          },
          { withCredentials: true }
        );

        const res = response.data;
        alert(res.message);

        // Redirect to home page when form submitted successfully
        if (response.status === 200) {
          navigate(`/`);
        }
      } catch (error) {
        const errorMessage = error.response.data.message;
        alert(errorMessage);
      }
    } else {
      alert("Invalid Spotify track URL, please try again.");
    }
  };

  return (
    <>
      <div className="SubForm p-3">
        <form
          onSubmit={(e) => {
            handleSubmit(e);
          }}
        >
          <div className="block p-3 w-full rounded-lg shadow-lg bg-transparent border-1 border-indigo-900">
            <div className="flex text-center justify-center items-center">
              <img
                src="/images/vs.png"
                className="md:w-1/5 w-1/4 h-auto mb-8"
                alt="SoundOff Logo"
              />
            </div>

            <h1 className="text-white text-2xl font-semibold uppercase">
              Contest Submission
            </h1>
            <br />
            <div className="form-group mb-6">
              <input
                value={link}
                required
                onChange={(e) => {
                  handleLinkChange(e);
                }}
                className="form-control block
                w-full
                px-3
                py-1.5
                text-base
                font-normal
                bg-black 
                border-2 border-indigo-600 text-white
                bg-clip-padding
                rounded
                transition
                ease-in-out
                m-0
              focus:border-green-600 focus:outline-none"
                id=""
                placeholder="Song Link (Spotify)"
              />
            </div>
            <div className="form-group mb-6">
              <input
                type="email"
                value={email}
                required
                onChange={(e) => {
                  handleEmailChange(e);
                }}
                className="form-control block
                w-full
                px-3
                py-1.5
                text-base
                font-normal
                bg-black 
                border-2 border-indigo-600 text-white
                bg-clip-padding
                rounded
                transition
                ease-in-out
                m-0
              focus:border-green-600 focus:outline-none"
                id=""
                placeholder="Email address"
              />
            </div>

            <div className="form-group mb-6">
              <input
                type="text"
                value={referral}
                onChange={(e) => {
                  handleReferralChange(e);
                }}
                className="form-control block
                w-full
                px-3
                py-1.5
                text-base
                font-normal
                bg-black 
                border-2 border-indigo-600 text-white
                bg-clip-padding
                rounded
                transition
                ease-in-out
                m-0
              focus:border-green-600 focus:outline-none"
                id=""
                placeholder="Referral Code (Optional)"
              />
            </div>

            <div className="form-group mb-6">
              <select
                required
                onChange={(e) => {
                  handleCategoryChange(e);
                }}
                defaultValue=""
                className="form-control block
                w-full
                px-3
                py-1.5
                text-base
                font-normal
                bg-black 
                border-2 border-indigo-600 text-white
                bg-clip-padding
                rounded
                transition
                ease-in-out
                m-0
              focus:border-green-600 focus:outline-none"
              >
                <option value="" disabled>
                  Choose a channel
                </option>
                {channels &&
                  channels.reverse().map((cat) => (
                    <option
                      value={cat.description}
                      name={cat.name}
                      key={cat.id}
                    >
                      {cat.name} ({cat.genre})
                    </option>
                  ))}
              </select>
            </div>

            <div className="self-center md:w-96 text-center mb-6 text-md">
              <div className="-mt-1 mb-6">
                <span className="text-white font-bold lg:text-lg md:text-md text-sm">
                  Contest description
                  <p className="text-white font-normal lg:text-lg md:text-md text-sm pt-1.5">
                    {description ? description : "..."}
                  </p>
                </span>
              </div>
            </div>

            <button
              type="submit"
              className="
              w-full
              px-6
              py-3
              bg-blue-700
              text-white
              font-semibold
              md:text-md text-sm
              leading-tight
              rounded-md
              shadow-md
              hover:bg-purple-700 hover:shadow-lg
              focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0
              active:bg-purple-800 active:shadow-lg
              transition
              duration-150
              ease-in-out"
            >
              Submit
            </button>
          </div>
        </form>
      </div>
      <Footer />
    </>
  );
};

export default Submission;
